/* eslint-disable no-console */
const transformConstructorResponseForCarousel = recommendations => {
    var results = [];
    recommendations.forEach(recommendation => {
        const recommendationData = recommendation.data;
        const transformedRecommendation = {
            badgeAltText: recommendationData.currentSku.imageAltText,
            biExclusiveLevel: recommendationData.currentSku.biExclusivityLevel,
            brandName: recommendationData.brandName,
            starRatings: recommendationData.rating,
            image: recommendationData.image_url,
            isAppExclusive: recommendationData.isAppExclusive,
            isBiOnly: recommendationData.currentSku.isBI,
            isFirstAccess: recommendationData.currentSku.isFirstAccess,
            isFree: recommendationData.currentSku.isFree,
            isLimitedEdition: recommendationData.currentSku.isLimitedEdition,
            isLimitedQuantity: recommendationData.currentSku.isLimitedQuantity,
            isLimitedTimeOffer: recommendationData.currentSku.isLimitedTimeOffer,
            isNew: recommendationData.currentSku.isNew,
            isOnlineOnly: recommendationData.currentSku.isOnlineOnly,
            isOutOfStock: recommendationData.currentSku.isOutOfStock,
            isSephoraExclusive: recommendationData.currentSku.isSephoraExclusive,
            listPrice: '$' + recommendationData.currentSku.listPrice,
            productId: recommendationData.id,
            productName: recommendation.value,
            skuId: recommendationData.currentSku.skuId,
            skuImages: {
                imageUrl: recommendationData.image_url
            },
            smallImage: recommendationData.currentSku.skuImages.image50,
            targetUrl: recommendationData.url,
            variationType: recommendationData.currentSku.variationValue,
            variationTypeDisplayName: recommendationData.currentSku.variationValue,
            variationValue: recommendationData.currentSku.variationValue
        };

        results.push(transformedRecommendation);
    });

    return results;
};

const getConstructorRecommendations = (podId, params) => {
    if (global.constructorio) {
        return global.constructorio.recommendations.getRecommendations(podId, params);
    } else {
        return Promise.reject(new Error('Constructor io not initialized'));
    }
};

module.exports = {
    transformConstructorResponseForCarousel,
    getConstructorRecommendations
};
